import { Analytics } from '../../../../helpers/analyticsMiddleware';
import { QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import { ModalType } from '../../../../redux/ui/typings';
var getHeaderAnalyticsTags = function (step, modalType, isRedispute) {
    var isCreditAlreadyIssuedView = step === QuestionnaireFlow.CancelDispute ||
        step === QuestionnaireFlow.CreditDetails ||
        step === QuestionnaireFlow.Start;
    if (isRedispute && step === QuestionnaireFlow.Start) {
        return {
            headerDataReason: 'x button',
            headerDataTitle: Analytics.DisputeTransaction,
            headerDataType: Analytics.Redispute
        };
    }
    if (modalType === ModalType.Questionnaire && isCreditAlreadyIssuedView) {
        return {
            headerDataReason: 'x button',
            headerDataType: Analytics.CreditAlreadyIssued
        };
    }
    return {
        headerDataReason: 'x button',
        headerDataTitle: Analytics.DisputeTransaction,
        headerDataType: Analytics.DisputeTransaction
    };
};
export default getHeaderAnalyticsTags;
//# sourceMappingURL=getHeaderAnalyticsTags.js.map